import { combineReducers } from "redux";

import landing from "./landing";
import contacts from "./contacts";

// app-specific reducers
import AppTrials from "./clinicalTrials";
import AppPublications from "./publications";
import AppLocations from "./locations";
import AppAffiliations from "./affiliations";
import AppExperts from "./experts";
import AppExpertSummary from "./expertSummary";
import AppNetwork from "./network";
import AppSocialMedia from "./socialMedia";
import AppCongresses from "./congresses";
import AppMedicalBodies from "./medicalBodies";
import AppOtherMedia from "./otherMedia";
import AppSpecialityCentre from "./specialityCentre";

export default combineReducers({
  landing,
  contacts,
  AppExperts,
  AppExpertSummary,
  AppAffiliations,
  AppLocations,
  AppTrials,
  AppCongresses,
  AppMedicalBodies,
  AppNetwork,
  AppSocialMedia,
  AppOtherMedia,
  AppSpecialityCentre,
  AppPublications
});
